import { GlobalService } from 'src/app/global.service';

import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode, MatDialog } from '@angular/material';

@Component({
  selector: 'app-monthly-institution-bill',
  templateUrl: './monthly-institution-bill.component.html',
  styleUrls: ['./monthly-institution-bill.component.scss']
})
export class MonthlyInstitutionBillComponent implements OnInit {
  from_date: any;
  to_date: any;
  is_document_available: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  seleted_option_type: any = 'by_business_type';
  business_type_list = [];
  business_list = [];
  selected_product_option: any = null;
  entered_booth_number: any = null;
  title: any;
  show_selection = true;

  constructor(private httpService: HttpService, private dialog: MatDialog, private global: GlobalService) {
    this.title = this.global._active_display_name;
    this.httpService.getEmployeeUserType().subscribe((data) => {
      console.log(data);
      if (data == 13) {
        this.show_selection = false;
        this.business_type_list = ['others'];
        this.seleted_option_type = 'by_business_type'
      } else {
        this.show_selection = true;
      }
    }, (error) => {
      console.error(error);
    });
  }

  getClicked() {
    let data_dict = {
      'from_date': this.from_date,
      'to_date': this.to_date,
      'option_type': this.seleted_option_type,
      'business_type_list': this.business_type_list
    };
    if (this.seleted_option_type === 'by_business_type') {
      if (this.business_type_list.length === 0) {
        alert('Please Fill Booth number or Institution Type');
        return false;
      }
    } else {
      if (this.entered_booth_number == null || this.entered_booth_number === '') {
        alert('Please Fill Booth number or Institution Type');
        return false;
      }
    }
    if (this.seleted_option_type === 'by_business') {
      let booth_list = this.entered_booth_number.split(',');
      data_dict['business_code_list'] = booth_list;
    }
    console.log(data_dict);
    data_dict['product_type'] = this.selected_product_option;
    this.is_document_available = false;
    this.httpService.getMonthlyInstituteAbstract(data_dict).subscribe((data) => {
      console.log(data);
      this.document_file = data;
      if (!data['is_data_available']) {
        alert('There No Order Availble');
        this.document_file = null;
        this.is_document_available = true;
        return false;
      }
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
    });
  }

  businessTypeOptionChanged(event, type_value) {
    this.document_file = null;
    if (event['checked']) {
      this.business_type_list.push(type_value);
    } else {
      let index = this.business_type_list.map((element) => {
        return element;
      }).indexOf(type_value);
      this.business_type_list.splice(index, 1);
    }
  }

  downloadClicked() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  changeEvent() {
    this.document_file = null;
  }

  ngOnInit() {
  }

}
